/**
 * Auto-adds a $0 "free bottle" line item whenever the cart contains
 * any item purchased on a subscription (selling plan). Removes it
 * automatically if no subscription items remain.
 */

(function () {
  const BOTTLE_VARIANT_ID = 49935467807001; // Water Bottle — Default Title
  const FLAG_ATTR = "properties[_auto_gift]"; // marks our line item so we can find/remove it safely

  let isProcessing = false;

  function cartHasSubscriptionItem(cart) {
    return cart.items.some((item) => !!item.selling_plan_allocation);
  }

  function cartHasBottle(cart) {
    return cart.items.find(
      (item) =>
        item.variant_id === BOTTLE_VARIANT_ID &&
        item.properties &&
        item.properties._auto_gift === "true"
    );
  }

  async function fetchCart() {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`);
    return res.json();
  }

  async function addBottle() {
    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: BOTTLE_VARIANT_ID,
            quantity: 1,
            properties: { _auto_gift: "true" },
          },
        ],
      }),
    });
  }

  async function removeBottle(line) {
    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: 0 }),
    });
  }

  async function refreshDrawer() {
    document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
  }

  async function syncBottle() {
    if (isProcessing) return;
    isProcessing = true;
    try {
      const cart = await fetchCart();
      const hasSub = cartHasSubscriptionItem(cart);
      const bottleLine = cartHasBottle(cart);
      const bottleLineIndex = bottleLine
        ? cart.items.indexOf(bottleLine) + 1
        : null;

      if (hasSub && !bottleLine) {
        await addBottle();
        await refreshDrawer();
      } else if (!hasSub && bottleLine) {
        await removeBottle(bottleLineIndex);
        await refreshDrawer();
      }
    } catch (err) {
      console.error("subscription-free-bottle sync failed:", err);
    } finally {
      isProcessing = false;
    }
  }

  // Watch for any cart-mutating request (add/change/update) regardless of
  // which theme UI (drawer, notification, or cart page) triggered it.
  // This avoids depending on the theme's internal pub/sub system, which
  // isn't reliably exposed to scripts outside the theme's own bundle.
  const CART_ENDPOINTS = ["/cart/add", "/cart/change", "/cart/update"];

  function isCartRequest(url) {
    return CART_ENDPOINTS.some((path) => url.includes(path));
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
    const request = originalFetch.apply(this, args);
    if (isCartRequest(url)) {
      request.then(() => syncBottle()).catch(() => {});
    }
    return request;
  };

  document.addEventListener("DOMContentLoaded", () => {
    // Also check on initial page load in case someone lands on a page
    // with a subscription already in cart (e.g. after checkout redirect back).
    syncBottle();
  });
})();